import { render, staticRenderFns } from "./TableChartViewer.vue?vue&type=template&id=10c2274c&scoped=true&"
import script from "./TableChartViewer.vue?vue&type=script&lang=js&"
export * from "./TableChartViewer.vue?vue&type=script&lang=js&"
import style0 from "./TableChartViewer.vue?vue&type=style&index=0&id=10c2274c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2274c",
  null
  
)

export default component.exports